import React, { Component } from 'react'
import Collapse from 'react-bootstrap/Collapse'
import { Link } from 'react-router-dom'

// styles
import './index.scss'

// Components
import Media from '../../components/Media'

// constants
import { OVERVIEW } from './constants'

class ProjectOverview extends Component {

  constructor(props) {
    super(props)
    this.state = {
      data: {},
      selectedWork: [],
      activeTabIndex: 0,
      isWorkTabVisible: true,
    }
  }

  componentDidMount = () => {
    this.getData()
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  // top open accordion if it is closed on mobile based on window width 
  handleResize = e => {
    const windowSize = window.innerWidth;
    if (windowSize >= 768)
      this.setState({ isWorkTabVisible: true });
    else {
      this.setState({ isWorkTabVisible: false });
    }
  };

  // this will fetch data from constants.js based on url
  getData = () => {
    const { match } = this.props
    const content = OVERVIEW.find(item => item.category === match.params.category)
    this.setState({ data: content || {}, selectedWork: content.work })
  }

  // this to active tab and fetch data based on tag
  handleWorkTab = (selectedTag, index) => {
    const { data } = this.state
    const portfolio = data.work && data.work.filter(item => item.tag.includes(selectedTag))
    this.setState({ selectedWork: portfolio, activeTabIndex: index })
    this.handleResize()
  }

  render = () => {
    const { location } = this.props
    const { data, activeTabIndex, selectedWork, isWorkTabVisible } = this.state

    return (
      <React.Fragment>
        {
          Object.keys(data).length > 0 &&
          <div className="project-overview">
            <div className={`page-banner ${data && data.bg} vh-center`}>
              <div className="banner-content">
                <h2>{data && data.title}</h2>
              </div>
            </div>

            <div className="f-w content">
              <div className="container">
                {data && data.para}
              </div>
            </div>

            {
              data && data.tags.length > 0 &&
              <div className="f-w work-btn-group content">
                <div className="container">

                  <div className="c-padd">
                    <button className="btn e-btn open"
                      onClick={() => this.setState({ isWorkTabVisible: !isWorkTabVisible })}
                      aria-controls="portfolio"
                    >
                      Select Categories
                    </button>
                  </div>

                  <Collapse in={isWorkTabVisible}>
                    <div>
                      <div className="flex lg-col-flex" id="portfolio">
                        {
                          data && data.tags && data.tags.map((item, i) => {
                            return (
                              <div key={`tag${i}`} className="c-padd">
                                <button
                                  type="button"
                                  className={`btn work-tab-btn ${activeTabIndex === i ? 'active' : ''}`}
                                  onClick={() => this.handleWorkTab(item, i)}>
                                  {item}
                                </button>
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                  </Collapse>
                </div>
              </div>
            }

            {
              selectedWork && selectedWork.length > 0 ?
                <div className="work-grid flex xlg-col-flex flex-wrap">
                  {
                    selectedWork.map((item, i) => {
                      return (
                        <div className="preview" key={`selected${i}`}>
                          <Link to={`${location.pathname}/${item.link}`}>

                            <div className={`bg-image height-4 ${item.bg}`}></div>
                            <h2>{item.title}</h2>
                          </Link>

                        </div>
                        // <Media
                        //   className={`work media-bg height-6 ${item.bg}`}
                        //   head={item.title}
                        //   link={`${location.pathname}/${item.link}`}
                        // />
                      )
                    })
                  }
                </div>

                :

                <div className="f-w">
                  <div className="container">
                    <div className="height-6 flex vh-center">
                      <p>No work found.</p>
                    </div>
                  </div>
                </div>
            }
          </div>
        }
      </React.Fragment>
    )
  }
}

export default ProjectOverview